import React from 'react';
import './buttons.scss';

const Button = ({ children, classes, danger,onClick, ...props }) => {
    return (
        <button className={`button ${classes}`} onClick={onClick} danger={danger} {...props}>{children}</button>
    )
}

export default Button